export const companyInfo = {
  name: 'Marvin AI',
  description: 'Leading provider of advanced energy market forecasting and asset optimization solutions using cutting-edge machine learning and deep learning technologies.',
  foundedYear: '2025',
  employees: '15+',
  headquarters: 'Budapest, HU',
  mission: 'To revolutionize energy market forecasting through advanced AI technologies and deliver unparalleled insights for optimal trading decisions.'
};

export const mockContactData = {
  company: 'Marvin AI',
  address: '1038 Budapest, Tündérliget utca 3/II B/5',
  phone: '+36 70 316 2136',
  email: 'marvin@marvinenergy.com',
  hours: 'Mon-Fri: 9:00 AM - 6:00 PM GMT'
};

export const technologyHighlights = [
  {
    title: 'Deep learning algorithms',
    description: 'Proprietary and usecase-specific neural networks developed and trained on real-world asset and energy market data for superior forecasting accuracy.',
    image: '/media/tech_1.jpg'
  },
  {
    title: 'In-house computing infrastructure',
    description: 'In-house computing infrastructure not only allows the rapid development and deployment of new models and algorithms, but also signals our long-term commitment to serving our clients with the best possible service.',
    image: '/media/tech_2.jpg'
  },
  {
    title: 'Advanced analytics',
    description: 'Minute-to-hourly resolution data gathering, validation and processing capabilities for up-to-the-minute market insights.',
    image: '/media/tech_3.jpg'
  }
];

export const marketData = {
  forecastAccuracy: '95.2%',
  dataPointsPerDay: '1M+',
  marketsCovered: '8+ Countries',
  updateFrequency: 'Real-time'
};

export const technologyLogos = [
  { name: 'TensorFlow', src: '/media/logos/TensorFlow_logo.svg.png' },
  { name: 'PyTorch', src: '/media/logos/pytorch_logo_icon_169823.svg' },
  { name: 'Hugging Face', src: '/media/logos/huggingface-color.png' },
  { name: 'Google Gemini', src: '/media/logos/Google_Gemini_logo.svg.png' },
  { name: 'Nvidia', src: '/media/logos/Nvidia_logo.svg.png' },
  { name: 'React', src: '/media/logos/React-Logo.png' },
  { name: 'Huge', src: '/media/logos/huge.png' },
  { name: 'Cursor AI', src: '/media/logos/cursor-ai.png' },
];
